import './Alert.scss';

interface AlertProps {
  id?: string;
  text?: string;
  className?: string;
}

export default function Alert({ id, text, className = '' }: AlertProps) {
  return (
    <div id={id} className={`alert ${className}`} role="alert">
      {text && <p>{text}</p>}
    </div>
  );
}
